export const MODULE_CLAIM = {
  eventsApplicationUrl: 'application_urls',
  faqs: 'faqs',
  featureFlags: 'feature_flags',
  media: 'media',
  modules: 'modules',
  notificationCategories: 'notification_categories',
  notificationCenterConfiguration: 'notification_center_configuration',
  notificationCenterFilters: 'notification_center_filters',
  notificationCenterTemplates: 'notification_center_templates',
  onboardingsplash: 'onboardingsplash',
  ruleEvents: 'rule_events',
  ruleGroups: 'rule_groups',
  rules: 'rules',
  targetGroups: 'target_groups',
} as const;
